import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_seller_allocation_queue_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    merchant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    customer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_qty_base: fromDatatype.NumericDatatypeInterface;
    sales_order_qty_uom: fromDatatype.NumericDatatypeInterface;
    sales_order_uom: fromDatatype.VarcharDatatypeInterface;
    allocated_qty_base: fromDatatype.NumericDatatypeInterface;
    allocated_uom: fromDatatype.VarcharDatatypeInterface;
    allocated_qty_uom: fromDatatype.NumericDatatypeInterface;
    seller_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
    seller_order_line_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    mkp_item_code: fromDatatype.VarcharDatatypeInterface;
    seller_order_unit_price_std: fromDatatype.NumericDatatypeInterface;
    seller_order_unit_price_net: fromDatatype.NumericDatatypeInterface;
    seller_order_unit_price_txn: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_std: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_net: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_txn: fromDatatype.NumericDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    status_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    app_id: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mkp_seller_allocation_queue_Rowclass implements bl_mkp_seller_allocation_queue_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    merchant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    customer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_qty_base: fromDatatype.NumericDatatypeInterface;
    sales_order_qty_uom: fromDatatype.NumericDatatypeInterface;
    sales_order_uom: fromDatatype.VarcharDatatypeInterface;
    allocated_qty_base: fromDatatype.NumericDatatypeInterface;
    allocated_uom: fromDatatype.VarcharDatatypeInterface;
    allocated_qty_uom: fromDatatype.NumericDatatypeInterface;
    seller_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
    seller_order_line_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    mkp_item_code: fromDatatype.VarcharDatatypeInterface;
    seller_order_unit_price_std: fromDatatype.NumericDatatypeInterface;
    seller_order_unit_price_net: fromDatatype.NumericDatatypeInterface;
    seller_order_unit_price_txn: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_std: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_net: fromDatatype.NumericDatatypeInterface;
    seller_order_amount_txn: fromDatatype.NumericDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    status_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    app_id: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}